import 'i18next';

import type about from '../public/locales/en/about.json';
import type common from '../public/locales/en/common.json';
import type error from '../public/locales/en/error.json';
import type home from '../public/locales/en/home.json';
import type pdp from '../public/locales/en/pdp.json';
import type plp from '../public/locales/en/plp.json';
import type profile from '../public/locales/en/profile.json';
import { DEFAULT_REGION, regions } from './utils/region';

type CommonTranslation = typeof common;
type PdpTranslations = typeof pdp;
type AboutTranslations = typeof about;
type PlpTranslations = typeof plp;
type ErrorTranslations = typeof error;
type HomeTranslations = typeof home;
type ProfileTranslations = typeof profile;

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'common';
    resources: {
      about: AboutTranslations;
      common: CommonTranslation;
      error: ErrorTranslations;
      home: HomeTranslations;
      pdp: PdpTranslations;
      plp: PlpTranslations;
      profile: ProfileTranslations;
    };
  }
}

export default {
  defaultNs: 'common',
  fallbackLng: DEFAULT_REGION.lang,
  fallbackNs: 'common',
  ns: ['common'],
  supportedLngs: regions.map(({ lang }) => lang)
};
